import { z } from 'zod';

export const RoadmapGanttPhaseSchema = z.enum(['planned', 'confirmed', 'all']);
export type RoadmapGanttPhase = z.infer<typeof RoadmapGanttPhaseSchema>;

export const RoadmapGanttSearchSchema = z.object({
  phase: RoadmapGanttPhaseSchema.catch('planned').default('planned'),
  freeText: z.string().optional(),
});
